import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const globalAdminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.user()?.roleCode === 'SUPER_ADMIN') {
    return true;
  }

  return router.createUrlTree(['/dashboard']);
};

